import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';

export const URI_PREFIX = checkIsStoryBookPath('notifications');
export const apiRoutes = {
  //Notifications Setting
  modulesActions: `${URI_PREFIX}/modules/actions/`,
  userActionsUpdate: `${URI_PREFIX}/modules/actions/update`,

  //Notifications Page
  allNotifications: `${URI_PREFIX}/`,
  loadNotificationRead: `${URI_PREFIX}/read`,

  //Notification popup
  NotificationsCount: `${URI_PREFIX}/count`,
  makeNotificationsSeen: `${URI_PREFIX}/make-seen`,
  NotificationsInApp: `${URI_PREFIX}/in-app`,
};
